import { parseAsString, useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';

/** Search param that holds the active `AppShell` docked toolbar panel key. */
export const ACTIVE_TOOLBAR_PANEL_PARAM = 'panel';

const parseAsToolbarPanelParam = parseAsString.withOptions({
  history: 'replace',
});

/**
 * URL-backed open/close state for `AppShell`'s docked toolbar panels. Panel
 * changes replace the current URL entry so opening, closing, and switching
 * panels do not pollute the browser back stack.
 *
 * `activePanelId` mirrors the `panel` search param (`null` when closed).
 */
export const useActiveToolbarPanelParam = () => {
  const [panelParam, setPanelParam] = useQueryState(
    ACTIVE_TOOLBAR_PANEL_PARAM,
    parseAsToolbarPanelParam,
  );

  const openPanel = useCallback(
    (key: string) => setPanelParam(key),
    [setPanelParam],
  );

  const closePanel = useCallback(() => setPanelParam(null), [setPanelParam]);

  return useMemo(
    () => ({
      activePanelId: panelParam,
      openPanel,
      closePanel,
    }),
    [panelParam, openPanel, closePanel],
  );
};
